// src/App.js
import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { TranslationProvider } from './context/TranslationContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Transformation from './components/Transformation';
import AISection from './components/AISection';
import Services from './components/Services';
import News from './components/News';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <TranslationProvider>
      <Header />
      <Hero />
      <About />
      <Transformation />
      <AISection />
      <Services />
      <News />
      <Contact />
      <Footer />
    </TranslationProvider>
  );
}
export default App;